import DOMPurify from 'isomorphic-dompurify';

export function sanitizeHtml(html) {
  let cleanedData = DOMPurify.sanitize(html);
  return cleanedData;
}
